import { Component, EventEmitter, Input, Output } from '@angular/core';

export type UpdateQuotaEvent = {
  id: string;
  value: number;
};

@Component({
  selector: 'ps-ui-edit-current-value',
  templateUrl: './edit-current-value.component.html',
  styleUrls: ['./edit-current-value.component.css'],
})
export class EditCurrentValueComponent {
  @Input() id!: string;
  @Input() value!: number;
  @Output() readonly cancel = new EventEmitter();
  @Output() readonly update = new EventEmitter<UpdateQuotaEvent>();

  updateQuota(event: Event) {
    event.preventDefault();
    const { id, value } = this;
    this.update.emit({ id, value });
  }

  cancelQuota() {
    this.cancel.emit(this.id);
  }
}
